export default "__VITE_ASSET__e7452c29__"